import React from 'react';
import { Link } from 'react-router-dom';

const CompactSideBar = () =>
{
    return(
            <div className="Sidebar">
                <Link to="/" className="item">
                    Home
                </Link>
            </div>          
    );
};

export default CompactSideBar;